import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalDraftsHandoff } from '@/pages/workspaces/transactional/message/overview/drafts/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/drafts',
)({
  component: JourneysTransactionalDraftsHandoff,
});
